/* 🤖 this file was generated by svg-to-ts */
export const mgcIconNotebookRegular: {
  name: 'notebook-regular';
  data: string;
} = {
  name: 'notebook-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.477 2.073c-.49.129-.931.471-1.212.941-.283.471-.265-.123-.263 9.014.002 7.648.007 8.251.071 8.495.187.716.843 1.318 1.567 1.437.179.03 2.068.04 6.08.032l5.82-.012.321-.101c.975-.309 1.752-1.096 2.027-2.057l.092-.322v-15l-.092-.322c-.275-.961-1.052-1.748-2.027-2.057l-.321-.101-5.9-.008c-5.48-.008-5.919-.003-6.163.061M8 12v8H6V4h2zm9.489-7.869c.213.125.375.318.454.539.079.223.079 14.437 0 14.66a1.038 1.038 0 0 1-.454.539l-.189.111-3.65.011-3.65.011V3.998l3.65.011 3.65.011z"/></svg>`
};
